import styled from "styled-components"
import { PlayMovieDiv, StyledIFrame, WatchMovieDiv } from "../../Utils/style"
import { colors } from "../../Utils/color"
import { useNavigate, useSearchParams } from "react-router-dom"
import { useEffect, useState } from "react"
import Select from "react-select"
import {
    customStyles,
    customTheme,
    episodesCustomStyles,
} from "../../Utils/selectStyle"
import { slugify } from "../../Components/MoviesSlider"
import { AddBannerDiv } from "../Home"
import AdsterraBanner from "../../Components/AdsterraBanner"

const EpisodesVideoHostsDiv = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 10px 0;

    @media screen and (max-width: 865px) {
        flex-direction: column;
        align-items: center;
        gap: 10px;
        margin: 10px 5px;
    }
    @media screen and (min-width: 639px) and (max-width: 865px) {
        margin: 10px 20px;
    }
`
const EpisodesDiv = styled.div`
    display: flex;
    gap: 10px;
    @media screen and (max-width: 865px) {
        width: 100%;
    }

    > button {
        color: ${colors.textColor};
        font-size: 1em;
        display: flex;
        align-items: center;
        gap: 10px;
        background-color: ${colors.backgrond};
        padding: 12px 16px 11px 16px;
        border: none;
        border-radius: 8px;
        cursor: pointer;
        @media screen and (max-width: 639px) {
            font-size: 1.5em;
            padding: 12px 50px 11px 50px;
        }
        @media screen and (min-width: 639px) and (max-width: 865px) {
            width: 100%;
            gap: 20px;
            justify-content: center;
        }

        span {
            @media screen and (max-width: 639px) {
                display: none;
            }
        }

        .fa-solid {
            font-size: 0.8em;
        }
    }

    #selectEpisode {
        width: 150px;
        @media screen and (max-width: 865px) {
            width: 100%;
        }
    }
`
const VideoHostsDiv = styled.div`
    width: 250px;
    position: relative;
    color: ${colors.textColor};
    @media screen and (max-width: 865px) {
        width: 100%;
    }
`
const SaisonDetailsDiv = styled.div`
    display: flex;
    flex-direction: column;
    margin: 20px 0;
    border-radius: 0;
    gap: 20px;
    background-color: black;
    padding: 20px;

    @media screen and (min-width: 480px) {
        flex-direction: row;
        border-radius: 20px;
    }
    @media screen and (min-width: 768px) and (max-width: 1024px) {
        gap: 15px;
    }

    > img {
        display: none;
        border-radius: 10px;
        background-color: ${colors.secondary};
        @media screen and (min-width: 768px) {
            display: block;
            width: 20vh;
            height: 26vh;
        }
    }

    > .infoSaison {
        width: 80%;
    }

    > div {
        display: flex;
        flex-direction: column;
        gap: 5px;
        text-align: justify;
        @media screen and (min-width: 768px) {
            gap: 10px;
        }

        p {
            font-size: 1rem;
        }

        h3,
        p {
            margin: 0;
        }
    }
`
const SaisonDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px 0 40px 0;

    h2 {
        font-size: 2.15em;
        gap: 10px;
        align-items: start;
        margin: 30px 10px;

        @media screen and (min-width: 768px) {
            font-size: 2.5em;
        }

        @media screen and (min-width: 1024px) {
            font-size: 3em;
            margin: 0;
        }
    }
    .fa-solid {
        color: white;
        font-size: 2em;
        cursor: pointer;
        &:hover {
            color: ${colors.primary};
        }
    }
`

function WatchSerie() {
    const [searchParams, setSearchParams] = useSearchParams()

    const serieID = searchParams.get("serie_id")
    const seasonNumber = searchParams.get("saison")

    const [nbSaisons, setNBSaisons] = useState(1)

    const [play, setPlay] = useState(false)
    const [frame, setFrame] = useState(false)
    const [serieInfos, setSerieInfos] = useState([])
    const [episodesOptions, setEpisodesOptions] = useState([])
    const [date, setDate] = useState()

    const [prevBlock, setPrevBlock] = useState(true)
    const [nextBlock, setNextBlock] = useState(false)

    const options = [
        { value: "uqload_link", label: "UQLOAD" },
        { value: "dood_link", label: "DOOD" },
        { value: "voe_link", label: "VOE" },
        { value: "filemoon_link", label: "FILEMOON" },
    ]

    const [selectedHost, setSelectedHost] = useState(options[0])
    const [selectedEpisode, setSelectedEpisode] = useState({
        label: "épisode 1",
        value: 1,
    })

    const fetchSerie = async (nbSeason, id) => {
        try {
            const API_BASE =
                process.env.NODE_ENV === "development"
                    ? "http://127.0.0.1:8787"
                    : window.location.origin

            const response = await fetch(
                `${API_BASE}/api/series/saison?saison=${nbSeason}&serie_id=${id}`,
            )
            const json = await response.json()
            setSerieInfos(json.saison[0])
            setNBSaisons(json.saison[0].nb_saisons)

            const array = []
            for (let i = 1; i <= json.saison[0].nb_episodes; i++) {
                array.push({ value: i, label: "épisode " + i })
            }
            setEpisodesOptions(array)

            const date_sortie = new Date(json.saison[0].date_sortie_saison)

            setDate(
                date_sortie.toLocaleDateString("fr-FR", {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                }),
            )

            document.title = `${json.saison[0].titre ?? "serie"} | saison ${
                json.saison[0].nb_saisons
            } en streaming complet`
        } catch (error) {
            console.log("Fetch error: ", error)
        }
    }

    useEffect(() => {
        const params = {
            serie_id: serieID,
            saison: seasonNumber,
            episode: selectedEpisode.value,
        }

        setSearchParams(params, { replace: true })

        fetchSerie(seasonNumber, serieID)
    }, [seasonNumber, serieID, selectedEpisode.value, setSearchParams])

    const [hostUrl, setHostUrl] = useState(null)

    const handleOptionChange = async (option) => {
        setSelectedHost(option)
        const result = await fetchHostLink(selectedEpisode.value, option.value)
        const hostLink = Object.values(result)[0]
        setHostUrl(hostLink)
    }
    const handleEpisodeChange = async (option) => {
        setSelectedEpisode(option)
        const result = await fetchHostLink(option.value, selectedHost.value)
        const hostLink = Object.values(result)[0]
        setHostUrl(hostLink)

        const params = {
            serie_id: serieID,
            saison: seasonNumber,
            episode: option.value,
        }

        setSearchParams(params, { replace: true })
    }

    const fetchHostLink = async (episode, host) => {
        try {
            const response = await fetch(
                `/api/series/episode?saison_id=${serieInfos.saison_id}&saison=${seasonNumber}&episode=${episode}&host=${host}`,
            )
            const json = await response.json()
            return json.episode
        } catch (error) {
            console.log("Fetch error: ", error)
            return error
        }
    }

    const watchSerieHandleClick = async (e) => {
        e.preventDefault()

        const result = await fetchHostLink(
            selectedEpisode.value,
            selectedHost.value,
        )
        const hostLink = Object.values(result)[0]
        setHostUrl(hostLink)

        setPlay(true)
        setFrame(true)
    }

    const switchEpisode = (btnID) => {
        setHostUrl("")
        const currentIndex = episodesOptions.findIndex(
            (option) => option.value === selectedEpisode.value,
        )

        if (btnID === "prevBtn") {
            if (selectedEpisode.value > 1) {
                const prevIndex = currentIndex - 1
                setSelectedEpisode(episodesOptions[prevIndex])

                setNextBlock(false)
                if (prevIndex <= 1) {
                    setPrevBlock(true)
                }

                setPlay(false)
                setFrame(false)
            }
        } else if (btnID === "nextBtn") {
            if (selectedEpisode.value < episodesOptions.length) {
                const nextIndex = currentIndex + 1
                setSelectedEpisode(episodesOptions[nextIndex])

                setPrevBlock(false)
                if (nextIndex + 1 === episodesOptions.length) {
                    setNextBlock(true)
                }

                setPlay(false)
                setFrame(false)
            }
        }
    }

    const navigate = useNavigate()

    const navigateToSerieInfos = () => {
        const urlTitle = slugify(serieInfos.titre)

        navigate(`/serie/${urlTitle}?serie_id=${serieInfos.id}`)
    }

    const showSeasonHandleClick = (number) => {
        navigate(
            `/serie/watch/${serieInfos.titre}?serie_id=${serieID}&saison=${number}`,
        )
    }

    const isMobile = window.innerWidth < 768

    return (
        <WatchMovieDiv>
            <h1
                className="watchSerieH1"
                style={{ cursor: "pointer" }}
                onClick={() => navigateToSerieInfos()}
            >
                <span></span>
                {serieInfos.titre}
            </h1>

            <SaisonDiv>
                <i
                    className="fa-solid fa-chevron-left"
                    style={{
                        visibility:
                            Number(seasonNumber) === 1 ? "hidden" : "visible",
                    }}
                    onClick={() => {
                        showSeasonHandleClick(Number(seasonNumber) - 1)
                    }}
                ></i>
                <h2>Saison {seasonNumber}</h2>
                <i
                    className="fa-solid fa-chevron-right"
                    style={{
                        visibility:
                            Number(seasonNumber) === Number(nbSaisons)
                                ? "hidden"
                                : "visible",
                    }}
                    onClick={() => {
                        showSeasonHandleClick(Number(seasonNumber) + 1)
                    }}
                ></i>
            </SaisonDiv>
            <EpisodesVideoHostsDiv>
                <EpisodesDiv>
                    <button
                        prevBlock={prevBlock}
                        id="prevBtn"
                        style={{
                            color: prevBlock
                                ? "rgba(250, 250, 250, .3)"
                                : colors.textColor,
                            cursor: prevBlock ? "not-allowed" : "pointer",
                        }}
                        onClick={() => switchEpisode("prevBtn")}
                    >
                        <i className="fa-solid fa-chevron-left"></i>
                        <span>Épisode précédent</span>
                    </button>
                    <Select
                        id="selectEpisode"
                        options={episodesOptions}
                        styles={episodesCustomStyles}
                        theme={customTheme}
                        isSearchable={false}
                        value={selectedEpisode}
                        onChange={handleEpisodeChange}
                        menuPortalTarget={null}
                        defaultValue={{
                            label: "épisode 1",
                            value: 1,
                        }}
                    />
                    <button
                        nextBlock={nextBlock}
                        id="nextBtn"
                        style={{
                            color: nextBlock
                                ? "rgba(250, 250, 250, .3)"
                                : colors.textColor,
                            cursor: nextBlock ? "not-allowed" : "pointer",
                        }}
                        onClick={() => switchEpisode("nextBtn")}
                    >
                        <span>Épisode suivant</span>
                        <i className="fa-solid fa-chevron-right"></i>
                    </button>
                </EpisodesDiv>

                <VideoHostsDiv>
                    <Select
                        id="selectHost"
                        options={options}
                        styles={customStyles}
                        theme={customTheme}
                        isSearchable={false}
                        onChange={handleOptionChange}
                        defaultValue={options[0]}
                    />
                </VideoHostsDiv>
            </EpisodesVideoHostsDiv>

            <PlayMovieDiv
                play={play}
                style={{ display: play ? "none" : "block" }}
            >
                <img src={serieInfos.cover_saison} alt="Movie cover" />
                <button id="playSerieBTN" onClick={watchSerieHandleClick}>
                    <i class="fa-solid fa-play"></i>
                    Regarder
                </button>
            </PlayMovieDiv>

            <StyledIFrame
                id="watchSerieFrame"
                style={{ display: frame ? "block" : "none" }}
                title="MoviesLink"
                hostUrl={hostUrl}
                setHostUrl={setHostUrl}
                src={hostUrl}
                allow="fullscreen; autoplay; encrypted-media; picture-in-picture;"
                webkitAllowFullScreen
                mozallowfullscreen
                allowfullscreen
                frameborder="0"
            ></StyledIFrame>

            <AddBannerDiv style={{ marginTop: "5px" }}>
                <p>
                    Cliquer sur les pub est le meilleur moyen de nous soutenir
                </p>
                {isMobile ? (
                    <AdsterraBanner
                        keyId="36095d1eafe994c25e794db19ac32ddd"
                        width={320}
                        height={50}
                    />
                ) : (
                    <AdsterraBanner
                        keyId="dcfa5d9b41f84b62a0d227806e4b1618"
                        width={728}
                        height={90}
                    />
                )}
            </AddBannerDiv>

            <SaisonDetailsDiv>
                <img src={serieInfos.cover_saison} alt="Movie cover" />
                <div className="synopsis">
                    <h3>Synopsis Saison</h3>
                    <p>{serieInfos.synopsis_saison}</p>
                </div>
                <div className="infoSaison">
                    <h3>Infos Saison</h3>
                    <p>{serieInfos.nb_episodes} episodes</p>
                    <p>Diffusée à partir de : {date}</p>
                    <h3>Note Saison</h3>
                    <h3>{serieInfos.note_saison}</h3>
                </div>
            </SaisonDetailsDiv>
        </WatchMovieDiv>
    )
}

export default WatchSerie
